<template>
    <div class="products">
        <div class="buttons-section flex">
            <div
                class="text-center --green pointer flex"
                v-ripple
                @click="getProductCategories"
            >
                <div class="icon add flex">
                    <img src="@/assets/MainDashboard/Products/Add.svg" alt="" />
                </div>
                Add new products
            </div>

            <div
                class="text-center pointer flex"
                style="color: #9b4da8"
                v-ripple
            >
                <div class="icon promote flex">
                    <img
                        src="@/assets/MainDashboard/Products/Promote.svg"
                        alt=""
                    />
                </div>
                Promote a product
            </div>
        </div>

        <div class="figures flex">
            <p class="my-0 --font">{{ heading }}</p>

            <div class="flex">
                <pagination
                    :total="totalData"
					:perPage="productPerPage"
                    ref="paginationRef"
                    @changePage="getProductList()"
                />
                <p :class="{'active' : !filter && !order}" @click="filterOrOrder('', '')">All Products</p>
                <p :class="{'active' : filter === 'new_added'}" @click="filterOrOrder('new_added', '')">Newly Added</p>
                <p :class="{'active' : order === 'high_selling'}" @click="filterOrOrder('', 'high_selling')">Max lead</p>
                <p :class="{'active' : order === 'low_selling'}" @click="filterOrOrder('', 'low_selling')">Min lead</p>
                <p :class="{'active' : filter === 'discounted'}" @click="filterOrOrder('discounted', '')">Discounted</p>
                <p :class="{'active' : filter === 'in_stock'}" @click="filterOrOrder('in_stock', '')">In Stock</p>
                <p :class="{'active' : filter === 'out_stock'}" @click="filterOrOrder('out_stock', '')">Out of Stock</p>
            </div>
        </div>

        <div class="products-card-section">
            <product-card
                v-for="(card, index) in data"
                :key="index"
                :item="card"
				@editProduct="getProductDetailsAndOpenModal"
				@view="getProductDetailsAndOpenModal"
				@refresh="getProductList"
            />
        </div>

        <add-products-modal
            :dialog="addProductDialog"
            ref="addProductRef"
            @closeModal="addProductDialog = false"
            @openCustomProductModal="openCustomProductModal"
			@refresh="getProductList"
        />

        <custom-products-modal
            :dialog="customProductDialog"
            @close="customProductDialog = false"
			ref="customProductModalRef"
			@refresh="getProductList"
        />

        <product-details 
			:dialog="productDetailsDialog" 
			:data="productDetails" 
			@close="productDetailsDialog = false; productDetails = {}" />
		
    </div>
</template>

<script>
import productCard from "./components/product-card.vue";
import addProductModal from "../Common/add-retailers__products.vue";
import addCustomProduct from "./components/add-custom-product.vue";
import pagination from "../Common/pagination.vue";
import API_URL from "../../../helpers/apiUrls";
import accessToken from "../../../helpers/accessToken";
import { eventBus } from "../../../main";
import productDetails from "./components/product-details.vue";

export default {
	name: "products",

	data() {
		return {
			data: [],
			addProductDialog: false,
			customProductDialog: false,
			productDetailsDialog : false,
			productDetails : {},
			totalData: 0,
			heading: "",
			filter : '',
			order : '',
			productPerPage : 50
		};
	},
	mounted() {
		this.getProductList();

		eventBus.$on("loadMore", () => this.getProductCategories());
	},

	methods: {
		openCustomProductModal() {
			this.customProductDialog = true;
			this.$refs.addProductRef.type = 'custom';
			setTimeout(() => {
				this.$refs.addProductRef.dialog = false;
			}, 500);
		},

		getProductCategories() {
			this.$refs.addProductRef.type = 'create';
			this.$store.state.productsStore.addProductModalPaginationData.page = 1;
			this.$store.dispatch("productsStore/getProductCategories");
		},

		getProductList() {
			this.toggleLoader(true);
			const successHandler = (response) => {
				if (response.status === 200) {
					this.data = response.data.data;
					this.totalData = response.data.total_count;
					this.heading = response.data.heading;
					this.toggleLoader(false);
				}
			};

			const errorHandler = (error) => {
				this.showToast("Something went wrong internally!", "error", 10000);
				this.toggleLoader(false);
			};

			const headers = {
				Authorization: `Bearer ${accessToken.getAccessToken()}`,
			};

			const data = {
				page: this.$refs.paginationRef.page,
				data_per_page: this.productPerPage,
			};

			if(this.filter)
				data['filter'] = this.filter;
			
			if(this.order)
				data['order'] = this.order;

			this.requestGET(
				API_URL.products__list,
				data,
				headers,
				successHandler,
				errorHandler
			);
		},

		filterOrOrder(filter, order) {
			if(filter) {
				this.filter = filter;
				this.order = '';
			}
			else if(order) {
				this.order = order;
				this.filter = '';
			}
			else {
				this.filter = '';
				this.order = '';
			}
			this.getProductList();
        },

		getProductDetailsAndOpenModal(data) {
			this.toggleLoader(true);
			const successHandler = response => {
				this.toggleLoader(false);
				if(response.status === 200) {
					if(data.type === 'editProduct')
						this.openCustomProductModalForEdit(data.ID, response);
						
					if(data.type === 'editPrice')
						this.openPriceModal(data.ID, response);
						
					if(data.type === 'view')
						this.openDetailsModal(data.ID, response);
				}
			}

			const errorHandler = error => {
				this.showToast('Something went wrong internally!', 'error', 10000)
				console.log(error);
				this.toggleLoader(false);
			}

			const headers = {
				Authorization: `Bearer ${accessToken.getAccessToken()}`,
			}

			this.requestGET(
				`${API_URL.products__historicalProducts}/${data.ID}`,
				{},
				headers,
				successHandler,
				errorHandler
			)
		},

		openCustomProductModalForEdit(ID, response) {
			this.$refs.customProductModalRef.productData.name = response.data.product_name;
			this.$refs.customProductModalRef.productData.description = response.data.product_description;
			this.$refs.customProductModalRef.productData.price = response.data.maximum_retail_price;
			this.$refs.customProductModalRef.productData.sellingPrice=response.data.selling_price;
			this.$refs.customProductModalRef.productData.quantity = response.data.product_size;

this.$refs.customProductModalRef.productData.length = response.data.length;
			this.$refs.customProductModalRef.productData.breadth=response.data.breadth;
			this.$refs.customProductModalRef.productData.height = response.data.height;
			this.$refs.customProductModalRef.productData.weight=response.data.weight;
			this.$refs.customProductModalRef.productData.hsn_code = response.data.hsn_code;

			this.$store.state.mainStore.uploadedImages = 
				response.data.images.length ? [{id : response.data.images[0].image_id, image : response.data.images[0].image}] : [];
			this.$refs.customProductModalRef.productData.isGlobal = response.data.is_global ? "true" : "false";
			this.$refs.customProductModalRef.productData.unitType = response.data.measuring_unit.id;
			this.$refs.customProductModalRef.productData.selectedCategory = response.data.category.id;
			this.$refs.customProductModalRef.productData.tax = response.data.tax_percentage;
			this.$refs.customProductModalRef.heading.text = 'Edit Product';
			this.$refs.customProductModalRef.heading.type = 'edit';
			this.$refs.addProductRef.type = 'edit';
			this.$refs.customProductModalRef.productIDToEdit = ID;
			this.customProductDialog = true;
			
		},

		openPriceModal(ID, response) {
			this.$refs.addProductRef.productDetails.images = response.data.images;
			this.$refs.addProductRef.productDetails.product_name = response.data.product_name;
			this.$refs.addProductRef.productDetails.product_size = response.data.product_size;
			this.$refs.addProductRef.productDetails.measuring_unit = response.data.measuring_unit;
			this.$refs.addProductRef.actualPrice = response.data.maximum_retail_price;
			this.$refs.addProductRef.myPrice = response.data.selling_price;
			this.$refs.addProductRef.tax = response.data.tax_percentage;
			this.$refs.addProductRef.currentStatus = 4;
			this.$refs.addProductRef.disableNextButton = false;
			this.$refs.addProductRef.productIDToEdit = ID;
			this.$refs.addProductRef.dialog = true;
		},

		openDetailsModal(ID, response) {
			this.productDetails = response.data;
			this.productDetailsDialog = true;
		}	
	},

	components: {
		"product-card": productCard,
		"add-products-modal": addProductModal,
		"custom-products-modal": addCustomProduct,
		"product-details" : productDetails,
		"pagination": pagination,
	},
};
</script>

<style lang="scss" scoped>
@import url("../Common/styles.css");

.buttons-section {
	justify-content: space-between;
}

.buttons-section > div {
	background-color: white;
	box-shadow: 1px 1px 1px rgba(17, 58, 34, 0.07);
	border-radius: 3px;
	width: 49%;
	height: 90px;
	position: relative;
	font-weight: 500;
	font-size: 18px;
	transition: 0.4s;
}

.buttons-section > div:nth-child(1):hover {
	background: #f4faf7;
}

.buttons-section > div:nth-child(2):hover {
	background: #f9f4fb;
}

.icon {
	border-radius: 7px;
	width: 70px;
	height: 70px;
	position: absolute;
	left: 10px;
}

.icon.add {
	background: #f4faf7;
}

.icon.promote {
	background: #f9f4fb;
}

.figures {
	justify-content: space-between;
	margin-top: 25px;
}

.figures > div p {
	font-size: 0.9rem;
	margin-left: 10px;
	color: #a6aca9;
	cursor: pointer;

	&.active {
		color: var(--primary-font);
	}
}

.products-card-section {
	margin-top: 5px;
	display: grid;
	grid-template-columns: repeat(3, 32%);
	justify-content: space-between;
	grid-template-rows: auto;
	grid-row-gap: 20px;
}

p {
	margin: 0;
}
</style>